import { targetsService,adminService } from "@/_services";
import { router } from "@/_helpers";
import moment from "moment";
import i18n from "@/_helpers/i18n";

const getTranslates = (items, field) => {
  return items.map(function(element) {
    if (element.translated === undefined) {
      element[field] = i18n.t("lang.optionlist." + element[field]);
      element.translated = true;
    }
    return element;
  });
};

export const onboarding = {
  namespaced: true,
  companyName:'',
  state: {
    tabs: {
      1: {
        id: 1,
        name: i18n.t("lang.label.personalizedsequence"),
        disabled: false,
      },
      2: {
        id: 2,
        name: i18n.t("lang.label.template"),
        disabled: false,
      },
    },
    modelCampaingStep:{
      campaign: {
        is_agency: 1,
      },
      campaign_steps: [],
      tabSelected:{
        id:0,
        disabled:false
      },
    },
    validationTarget: {
      status: 0,
      comment: "",
      label: "",
    },
    emailDataToken: [
      {
        "[prospect_last_name]": "",
        "[prospect_first_name]": "",
        "[prospect_city]": "",
        "[prospect_website_url]": "",
        "[prospect_company_name]": "",
        "[gender]": "M",
        "[prospect_job_title]": "Marketing",
        "[product_market_area]": "France",
        "[product_year_start]": "2011",
        "[product_name]": "",
        "[we_propose]": "",
        "[we_are_convinced]": "",
        "[in_few_words]": "",
        "[we_wanted_to_exchange_about]": "",
        "[the_idea_is_simple]": "",
        "[we_were_wondering_how]": "",
        "[what_we_created]": "",
        "[prospect_area]": "",
        "[argument_1]": "",
        "[argument_2]": "",
        "[argument_3]": "",
        "[ref_1]": "",
        "[ref_2]": "",
        "[ref_3]": "",
        "[custom_sentence]": "",
      },
    ],
    companyName: "",
    descriptions: [
      {
        substep: 3,
        arg: "what_we_created",
        order: 1,
      },
      {
        substep: 4,
        arg: "we_propose",
        order: 1,
      },
      {
        substep: 5,
        arg: "we_are_convinced",
        order: 1,
      },
      {
        substep: 6,
        arg: "in_few_words",
        order: 1,
      },
      {
        substep: 7,
        arg: "we_wanted_to_exchange_about",
        order: 1,
      },
      {
        substep: 8,
        arg: "the_idea_is_simple",
        order: 1,
      },
      {
        substep: 9,
        arg: "we_were_wondering_how",
        order: 1,
      },
      {
        substep: 10,
        arg: "prospect_area",
        order: 1,
      },
      {
        substep: 11,
        arg: "argument_1",
        order: 1,
      },
      {
        substep: 11,
        arg: "argument_2",
        order: 2,
      },
      {
        substep: 11,
        arg: "argument_3",
        order: 3,
      },
      {
        substep: 12,
        arg: "ref_1",
        order: 1,
      },
      {
        substep: 12,
        arg: "ref_2",
        order: 2,
      },
      {
        substep: 12,
        arg: "ref_3",
        order: 3,
      },
    ],
    step1Ready: false,
    step2Ready: false,
    readyToPrepear: false,
    loading: false,
    isDisable: false,
    disablednext: false,
    disabledskip: true,
    limitA: 1000,
    limitB: 50000,
    limitC: 20000,
    showback: true,
    shownext: true,
    orderId: 0,
    lang: "en",
    step: 1,
    substep: 0,
    orderName: "",
    size: {
      greater: 0,
      less: 0,
    },
    steps: [
      {
        min: 0,
        max: 13,
      },
      {
        min: 1,
        max: 5,
      },
      {
        min: 1,
        max: 1,
      },
    ],
    typeForm: "",
    productName: "",
    descriptionSell: "",
    offer_prospect:0,
    offer_benefits:"",
    offer_attractive:"",
    client_id:0,
    adminPrice: 0,
    previewTemplate: 1,
    website: "",
    target_status_id: null,
    user_id: null,
    toSettingAccount: false,
    apollo: {
      people: [],
      total_result: 0,
    },
    orderdata: {},
    select_list_sizes: [
      { id: 0, label: "1-10" },
      { id: 1, label: "11-20" },
      { id: 2, label: "21-50" },
      { id: 3, label: "51-100" },
      { id: 4, label: "101-200" },
      { id: 5, label: "201-500" },
      { id: 6, label: "501-1000" },
      { id: 7, label: "1001-2000" },
      { id: 8, label: "2001-5000" },
      { id: 9, label: "5001-10000" },
      { id: 10, label: "10001+" },
    ],
    step1: {
      we_propose: "",
      we_are_convinced: "",
      in_few_words: "",
      we_wanted_to_exchange_about: "",
      serviceDescription_5: "",
      the_idea_is_simple: "",
      serviceDescription_7: "",
      we_were_wondering_how: "",
      what_we_created: "",
      prospect_area: "",
      argument_1: "",
      argument_2: "",
      argument_3: "",
      ref_1: "",
      ref_2: "",
      ref_3: "",
    },
    target: {
      positions: [],
      departments: [],
      sizes: [],
      categories_jobs: {},
      sectors_include: [],
      sectors_exclude: [],
      contact_country: [],
      company_location: [],
      employees: {
        greater: 0,
        less: 0,
      },
    },
    step3: {
      appointmentVolume: 20,
      tag_id:"",
      launchDate: "",
      teamMembers: [],
      updateSales: [],
      appointmentPrice: "149",
      pausedDie:"",
    },
    summary: {
      progressBarColor: "bg-danger",
      progressBarPercentage: "width: 25%",
    },
  },
  mutations: {
    setOrderData(state) {
      state.orderdata = {
        target_id: state.orderId,
        language_id: state.language_id,
        name: state.step3.name,
        appt_quantity: state.step3.appointmentVolume,
        tag_id: state.step3.tag_id,
        salesRep: state.step3.teamMembers,
        preview_template: state.previewTemplate,
        data: {
          categories_level: state.target.positions,
          categories_function: state.target.departments,
          categories_industry: state.target.sectors_include,
          categories_not_industry: state.target.sectors_exclude,
          region: state.target.company_location,
          countries: state.target.contact_country,
          categories_jobs: state.target.categories_jobs,
          employees: state.size,
        },
        launch_date_campaign: state.step3.launchDate,
        name: state.orderName,
        description_sell: state.descriptionSell,
        product_name: state.productName,
        we_propose: state.step1.we_propose,
        we_are_convinced: state.step1.we_are_convinced,
        in_few_words: state.step1.in_few_words,
        we_wanted_to_exchange_about: state.step1.we_wanted_to_exchange_about,
        the_idea_is_simple: state.step1.the_idea_is_simple,
        we_were_wondering_how: state.step1.we_were_wondering_how,
        what_we_created: state.step1.what_we_created,
        prospect_area: state.step1.prospect_area,
        argument_1: state.step1.argument_1,
        argument_2: state.step1.argument_2,
        argument_3: state.step1.argument_3,
        ref_1: state.step1.ref_1,
        ref_2: state.step1.ref_2,
        ref_3: state.step1.ref_3,
        landing_page: state.website,
        user_id: state.user_id,
        closed: state.closed,
        offer_prospect:state.offer_prospect,
        offer_benefits:state.offer_benefits,
        offer_attractive:state.offer_attractive,
        client_id:state.client_id
      };

      let categories_jobs = {
        anyof:
          state.target.categories_jobs.anyof !== undefined
            ? state.target.categories_jobs.anyof
            : undefined,
        notanyof:
          state.target.categories_jobs.notanyof !== undefined
            ? state.target.categories_jobs.notanyof
            : undefined,
        known:
          state.target.categories_jobs.known !== undefined
            ? state.target.categories_jobs.known
            : undefined,
        unknown:
          state.target.categories_jobs.unknown !== undefined
            ? state.target.categories_jobs.unknown
            : undefined,
      };

      state.orderdata.data.categories_jobs = categories_jobs;

      if (state.language_id == 1) {
        state.lang = "fr";
      } else {
        if (state.language_id == 2) {
          state.lang = "en";
        } else {
          state.lang = "es";
        }
      }
    },
    clean(state) {
      state.lang = "";
      state.orderName = "";
      state.productName = "";
      state.descriptionSell = "";
      state.website = "";
      state.target_status_id = null;
      state.user_id = null;
      state.apollo.people = [];
      state.apollo.total_result = 0;
      state.step1.we_propose = "";
      state.step1.we_are_convinced = "";
      state.step1.in_few_words = "";
      state.step1.we_wanted_to_exchange_about = "";
      state.step1.the_idea_is_simple = "";
      state.step1.we_were_wondering_how = "";
      state.step1.what_we_created = "";
      state.step1.prospect_area = "";
      state.step1.argument_1 = "";
      state.step1.argument_2 = "";
      state.step1.argument_3 = "";
      state.step1.ref_1 = "";
      state.step1.ref_2 = "";
      state.step1.ref_3 = "";
      state.language_id = 0;
      state.step = 1;
      state.substep = 0;
      state.orderId = 0;
      state.target.positions = [];
      state.target.departments = [];
      state.target.sizes = [];
      state.target.sectors_exclude = [];
      state.target.sectors_include = [];
      state.target.contact_country = [];
      state.target.company_location = [];
      state.target.categories_jobs = {};
      state.step3.appointmentVolume = 20;
      state.step3.tag_id = null;
      state.step3.appointmentPrice = "149";
      state.step3.teamMembers = [];
      state.summary.progressBarColor = "bg-danger";
      state.summary.progressBarPercentage = "width:25%";
    },
    apolloData(state, apollo) {
      state.apollo = apollo;
      onboarding.mutations.calculatePrice(state);
    },
    updateAdminPrice(state, adminPrice) {
      state.adminPrice = adminPrice;
      onboarding.mutations.validateForm(state);
    },
    updatePreviewTemplate(state, previewTemplate) {
      state.previewTemplate = previewTemplate;
      onboarding.mutations.validateForm(state);
    },
    setTypeForm(state, type) {
      state.typeForm = type;
    },
    changeLang(state, lang) {
      state.lang = lang;
    },
    back(state) {
      if (state.steps[state.step - 1].min >= state.substep) {
        //si ya llegue al minimo
        if (state.step >= 1) {
          state.step = state.step - 1;
          state.substep = state.steps[state.step].min;
          state.shownext = true;
          return;
        } else {
          //volver al inicio de todo
          state.showback = false;
          state.shownext = true;
        }
      } else {
        state.substep = state.substep - 1;
      }
      if (
        state.typeForm !== "add" &&
        router.currentRoute.fullPath !==
          "/onboarding/" + state.step + "/" + state.substep
      ) {
        router.push("/onboarding/" + state.step + "/" + state.substep);
      }
    },
    next(state) {
      if (state.steps[state.step - 1].max < state.substep + 1) {
        //si ya llegue al minimo
        if (state.step < 3) {
          state.step = state.step + 1;
          state.substep = state.steps[state.step - 1].min;
          state.shownext = true;
        } else {
          state.shownext = false;
        }
      } else {
        state.substep = state.substep + 1;
      }
      if (
        state.typeForm !== "add" &&
        router.currentRoute.fullPath !==
          "/onboarding/" + state.step + "/" + state.substep
      ) {
        router.push("/onboarding/" + state.step + "/" + state.substep);
      }
    },
    validateForm(state) {
      state.step1Ready = true;
      state.step2Ready = false;
      state.readyToPrepear = true;

      /*if (state.previewTemplate == 1) {
        state.descriptions.forEach((r) => {
          if (state.step1Ready == true && !state.step1[r.arg]) {
            state.step1Ready = false;
          }
        });
      }*/
      if(!state.productName){
        state.step1Ready = false;
      }else{
         state.step1Ready = true;
      }

      if(!state.step3.tag_id){
        state.step1Ready = false;
      }

      if (state.typeForm == "onboarding") {
        if (state.step3.teamMembers.length == 0) {
          state.readyToPrepear = false;
        }
      } else {
        if (state.step3.updateSales.length == 0) {
          state.readyToPrepear = false;
        }
      }

      let items = Array();
      items.push(state.target.positions);
      items.push(state.target.departments);
      items.push(state.target.sectors_include);
      items.push(state.target.sectors_exclude);
      items.push(state.target.company_location);
      items.push(state.target.contact_country);
      items.push(state.target.categories_jobs);
      items.push(state.target.sizes);
      items.forEach((item) => {
        if (!state.step2Ready && item !== undefined && item.length > 0) {
          state.step2Ready = true;
        }
        if((item.anyof && item.anyof.length > 0) || (item.notanyof && item.notanyof.length > 0)){
          state.step2Ready = true;
        }
      });


      if (!state.website) {
        state.readyToPrepear = false;
      }

      if (!state.step2Ready) {
        state.readyToPrepear = false;
      }
      // if (!state.step1Ready) {
      //   state.readyToPrepear = false;
      // }
    },
    disableSkip(state) {
      if (state.step == 1) {
        switch (state.substep) {
          case 1:
            state.disabledskip = !state.productName;
            break;
          case 2:
            state.disabledskip = false;
            break;
          case 3:
            state.disabledskip = !state.step1.what_we_created;
            break;
          case 4:
            state.disabledskip = !state.step1.we_propose;
            break;
          case 5:
            state.disabledskip = !state.step1.we_are_convinced;
            break;
          case 6:
            state.disabledskip = !state.step1.in_few_words;
            break;
          case 7:
            state.disabledskip = !state.step1.we_wanted_to_exchange_about;
            break;
          case 8:
            state.disabledskip = !state.step1.the_idea_is_simple;
            break;
          case 9:
            state.disabledskip = !state.step1.we_were_wondering_how;
            break;
          case 10:
            state.disabledskip = !state.step1.prospect_area;
            break;
          case 11:
            state.disabledskip =
              !state.step1.argument_1 ||
              !state.step1.argument_2 ||
              !state.step1.argument_3;
            break;
          case 12:
            state.disabledskip =
              !state.step1.ref_1 || !state.step1.ref_2 || !state.step1.ref_3;
            break;
        }
      }
    },
    disableButton(state) {
      if (state.step == 1) {
        switch (state.substep) {
          case 1:
            state.disablednext = !state.productName || !state.step3.tag_id;
            break;
          case 2:
            state.disablednext = false;
            break;
          case 3:
            state.disablednext = !state.step1.what_we_created;
            break;
          case 4:
            state.disablednext = !state.step1.we_propose;
            break;
          case 5:
            state.disablednext = !state.step1.we_are_convinced;
            break;
          case 6:
            state.disablednext = !state.step1.in_few_words;
            break;
          case 7:
            state.disablednext = !state.step1.we_wanted_to_exchange_about;
            break;
          case 8:
            state.disablednext = !state.step1.the_idea_is_simple;
            break;
          case 9:
            state.disablednext = !state.step1.we_were_wondering_how;
            break;
          case 10:
            state.disablednext = !state.step1.prospect_area;
            break;
          case 11:
            state.disablednext =
              !state.step1.argument_1 ||
              !state.step1.argument_2 ||
              !state.step1.argument_3;
            break;
          case 12:
            state.disablednext =
              !state.step1.ref_1 || !state.step1.ref_2 || !state.step1.ref_3;
            break;
        }
      }
    },
    goTo(state, steps) {
      if (!steps.step) {
        state.step = parseInt(1);
      } else {
        state.step = parseInt(steps.step);
      }
      if (!steps.substep) {
        if (state.step == 3) {
          state.substep = parseInt(1);
        } else {
          state.substep = parseInt(0);
        }
      } else {
        state.substep = parseInt(steps.substep);
      }
      if (state.step == 2) {
        state.disablednext = false;
      }
    },
    goToStep(state, step) {
      if (step == null || step == undefined) {
        step = 3;
      }
      state.step = step;
      if (state.step == 2) {
        state.disablednext = false;
      }
      if (
        state.typeForm !== "add" &&
        router.currentRoute.fullPath !==
          "/onboarding/" + state.step + "/" + state.substep
      ) {
        router.push("/onboarding/" + state.step + "/" + state.substep);
      }
    },
    goToSubStep(state, substep) {
      if (substep == null || substep == undefined) {
        step = 1;
      }
      if (state.step == 3 && substep == 0) {
        state.substep = parseInt(1);
      } else {
        state.substep = substep;
      }
      if (
        state.typeForm !== "add" &&
        router.currentRoute.fullPath !==
          "/onboarding/" + state.step + "/" + state.substep
      ) {
        router.push("/onboarding/" + state.step + "/" + state.substep);
      }
    },
    updatePrice(state, price) {
      state.step3.appointmentPrice = price;
      onboarding.mutations.validateForm(state);
    },
    setOrderId(state, id) {
      state.orderId = id;
    },
    setTab(state, id) {
      state.modelCampaingStep.tabSelected.id = id;
    },
    setLanguageId(state, id) {
      state.language_id = id;
      if (state.language_id == 1) {
        state.lang = "fr";
      } else {
        if (state.language_id == 2) {
          state.lang = "en";
        } else {
          state.lang = "es";
        }
      }
    },
    updateOrderName(state, orderName) {
      state.orderName = orderName;
      onboarding.mutations.validateForm(state);
    },
    updateDescriptionSell(state, descriptionSell) {
      state.descriptionSell = descriptionSell;
      onboarding.mutations.validateForm(state);
    },
    updateOfferAttractive(state, offer_attractive) {
      state.offer_attractive = offer_attractive;
      onboarding.mutations.validateForm(state);
    },
    updateBenefitsOffer(state,offer_benefits){
      state.offer_benefits = offer_benefits
      onboarding.mutations.validateForm(state);
    },
    updateWebsite(state, website) {
      state.website = website;
      onboarding.mutations.validateForm(state);
    },
    updateTargetStatusId(state, targetStatusId) {
      state.target_status_id = targetStatusId;
      onboarding.mutations.validateForm(state);
    },
    updateProductName(state, productName) {
      state.productName = productName;
      onboarding.mutations.validateForm(state);
    },
    updateTagId(state, tagId) {
      state.step3.tag_id = tagId;
      onboarding.mutations.validateForm(state);
    },
    updateOfferProspect(state, offer) {
      state.offer_prospect = offer;
      onboarding.mutations.validateForm(state);
    },
    updateCompanyName(state, company) {
      state.companyName = company;
      onboarding.mutations.validateForm(state);
    },
    updateServiceDescription(state, args) {
      state.descriptions.forEach((r) => {
        if (r.substep == state.substep && args.order == r.order) {
          state.step1[r.arg] = args.text;
          state.emailDataToken[0]["[" + r.arg + "]"] = args.text;
          return;
        }
      });
      onboarding.mutations.validateForm(state);
    },
    updateDescription(state, args) {
      state.step1[args.field] = args.value;
      state.emailDataToken[0]["[" + args.field + "]"] = args.value;
      onboarding.mutations.validateForm(state);
    },
    updateAppointmentVolume(state, appointmentVolume) {
      state.step3.appointmentVolume = appointmentVolume;
      onboarding.mutations.validateForm(state);
    },
    updateLaunchDate(state, launchDate) {
      state.step3.launchDate = launchDate;
      onboarding.mutations.validateForm(state);
    },
    updateTeamMembers(state, array) {
      state.step3.teamMembers = array;
      onboarding.mutations.validateForm(state);
    },
    updateSales(state, array) {
      state.step3.updateSales = array;
      onboarding.mutations.validateForm(state);
    },
    updatePositions(state, array) {
      state.target.positions = array;
      onboarding.mutations.validateForm(state);
    },
    updateDepartments(state, array) {
      state.target.departments = array;
      onboarding.mutations.validateForm(state);
    },
    updateSizes(state, array) {
      state.target.sizes = array;
      onboarding.mutations.validateForm(state);
    },
    updateSectorsExclude(state, array) {
      state.target.sectors_exclude = array;
      onboarding.mutations.validateForm(state);
    },
    updateSectorsInclude(state, array) {
      state.target.sectors_include = array;
      onboarding.mutations.validateForm(state);
    },
    updateCategoryJobs(state, array) {
      state.target.categories_jobs = array;
      onboarding.mutations.validateForm(state);
    },
    updateCountries(state, array) {
      state.target.contact_country = array;
      onboarding.mutations.validateForm(state);
    },
    updateRegions(state, array) {
      state.target.company_location = array;
      onboarding.mutations.validateForm(state);
    },
    updateSummary(state, data) {
      state.summary.progressBarColor = data.progressBarColor;
      state.summary.progressBarPercentage = data.progressBarPercentage;
      onboarding.mutations.validateForm(state);
    },
    setEmailDataToken(state) {
      state.emailDataToken[0] = {
        "[prospect_last_name]": "",
        "[prospect_first_name]": "",
        "[prospect_city]": "",
        "[prospect_website_url]": "",
        "[prospect_company_name]": "AIVONI",
        "[my_company_name]": state.companyName,
        "[gender]": "M",
        "[prospect_job_title]": "Marketing",
        "[product_market_area]": "France",
        "[product_year_start]": "2011",
        "[product_name]": state.productName,
        "[we_propose]": state.step1.we_propose,
        "[we_are_convinced]": state.step1.we_are_convinced,
        "[in_few_words]": state.step1.in_few_words,
        "[we_wanted_to_exchange_about]":
          state.step1.we_wanted_to_exchange_about,
        "[the_idea_is_simple]": state.step1.the_idea_is_simple,
        "[we_were_wondering_how]": state.step1.we_were_wondering_how,
        "[what_we_created]": state.step1.what_we_created,
        "[prospect_area]": state.step1.prospect_area,
        "[argument_1]": state.step1.argument_1,
        "[argument_2]": state.step1.argument_2,
        "[argument_3]": state.step1.argument_3,
        "[ref_1]": state.step1.ref_1,
        "[ref_2]": state.step1.ref_2,
        "[ref_3]": state.step1.ref_3,
        "[custom_sentence]": "",
      };
    },
    loadTarget(state, target_id) {
      onboarding.mutations.clean(state);
      state.loading = true;
      state.orderId = target_id;
      targetsService.getTarget(target_id).then((response) => {
        if (response) {
          state.language_id = response.language_id;
          state.step3.tag_id = response.tag_id;
          state.companyName = response.company_name
          state.validationTarget.status = response.validation
            ? response.validation.status
            : 0;
          state.validationTarget.comment = response.validation
            ? response.validation.comment
            : "";
          if (state.validationTarget.status != 0) {
            if (state.validationTarget.status == 1) {
              state.validationTarget.label = i18n.t("lang.label.verified");
            } else {
              state.validationTarget.label = i18n.t("lang.label.nonverified");
            }
          } else {
            state.validationTarget.label = i18n.t("lang.label.unverified");
          }

          let lang = "es";
          if (response.language_id == 1) {
            lang = "fr";
          } else {
            if (response.language_id == 2) {
              lang = "en";
            }
          }
          state.adminPrice = response.admin_price;
          state.previewTemplate = response.preview_template;
          state.website = response.landing_page;
          state.closed = response.closed;
          state.descriptionSell = response.description_sell;
          state.step3.appointmentVolume = response.appt_quantity;
          state.client_id = response.client_id


          if (
            response.launch_date_campaign !== "" &&
            response.launch_date_campaign !== null &&
            response.launch_date_campaign !== "0000-00-00 00:00:00"
          ) {
            state.step3.launchDate = response.launch_date_campaign;
          } else {
            state.step3.launchDate = moment()
              .add(2, "weeks")
              .startOf("day")
              .format("YYYY-MM-DD");
          }
          state.lang = lang;
          state.language_id = response.language_id;
          state.orderName = response.name;
          state.productName = response.product_name;
          state.target_status_id = response.target_status_id;
          state.step3.pausedDie = new Date(response.paused).toLocaleDateString()
          state.user_id = response.user_id;
          state.descriptions.forEach((r) => {
            state.step1[r.arg] = response[r.arg];
          });
          if (response.data !== undefined) {
            state.target.positions = response.data.categories_level;
            state.target.departments = response.data.categories_function;
            state.target.contact_country = response.data.countries;
            state.target.company_location = response.data.region;
            state.target.categories_jobs = response.data.categories_jobs;
            if (_.has(response.data.employees, "keywords")) {
              state.target.sizes = [];
              state.size = { keywords: {} };
              state.size.keywords.greater =
                response.data.employees.keywords.greater;
              state.size.keywords.less = response.data.employees.keywords.less;
              state.select_list_sizes.forEach((item) => {
                let label = item.label.replace("+", "").split("-");
                let less = label[0];
                let greater = label[1];
                if (
                  less <= state.size.keywords.less &&
                  greater >= state.size.keywords.greater
                ) {
                  state.target.sizes.push(item.id);
                }
                if (
                  greater == undefined &&
                  state.size.keywords.less == "10000000"
                ) {
                  state.target.sizes.push(item.id);
                }
              });
            } else {
              if (_.has(response.data, "employees")) {
                if (response.data.employees.greater == undefined) {
                  state.target.sizes = response.data.employees;
                  let greater = 0;
                  let less = 0;
                  state.target.sizes.sort();
                  onboarding.mutations.calculateSize(state);
                }
              }
            }

            let arrayDataIndustry = [];
            if (Array.isArray(response.data.categories_industry)) {
              if (Array.isArray(response.data.categories_industry)) {
                arrayDataIndustry = response.data.categories_industry.filter(
                  (item) => item != null
                );
              }
            }
            state.target.sectors_include = arrayDataIndustry;

            let arrayDataNotIndustry = [];
            if (Array.isArray(response.data.categories_industry)) {
              if (Array.isArray(response.data.categories_not_industry)) {
                arrayDataNotIndustry = response.data.categories_not_industry.filter(
                  (item) => item != null
                );
              }
            }

            state.target.sectors_exclude = arrayDataNotIndustry;

            state.step3.appointmentPrice = response.appt_price;


              state.offer_benefits = response.offer_benefits ? response.offer_benefits : "" //Text Area
              state.offer_attractive = response.offer_attractive ? response.offer_attractive : "" //TexArea
              state.offer_prospect = response.offer_prospect ? response.offer_prospect : 0 //Diferentes propuestas Select


            if (response.salesRep) {
              state.step3.teamMembers = [];
              response.salesRep.forEach((item) => {
                let member = item;
                state.step3.teamMembers.push(member);
              });
            }

            onboarding.mutations.setEmailDataToken(state);

            onboarding.mutations.setOrderData(state);

            if (state.language_id == 1) {
              state.lang = "fr";
            } else {
              if (state.language_id == 2) {
                state.lang = "en";
              } else {
                state.lang = "es";
              }
            }

            onboarding.mutations.validateForm(state);
          }
          onboarding.mutations.loadCampaignStepTarget(state);


        }
      });
    },

    loadCampaignStepTarget(state){
      state.modelCampaingStep.campaign_steps = []
      let subjectFilter = {
        currentPage: 1,
        cantPerPage: 1,
        step: 1,
        campaign_step_template_type_id: 1,
        campaign_step_template_part_id: 2,
        isPreviewEmail: false,
        withTags: true,
        tag_id: state.step3.tag_id,
        language_id:state.language_id,
      };

       targetsService
        .loadCampaingStepTarget({ target_id: state.orderId })
        .then(async (res) => {
          if (res.length > 0 && res) {
            state.modelCampaingStep.campaign_steps = res;
            state.modelCampaingStep.tabSelected.id = 1;
            if(state.target_status_id !=3 ){
              state.modelCampaingStep.tabSelected.disabled = true;
              state.tabs[2].disabled = true
            }
            state.loading = false;
          } else {
            state.modelCampaingStep.tabSelected.id = 2;
            if(state.target_status_id != 3){
              state.modelCampaingStep.tabSelected.disabled = true;
              //state.tabs[1].disabled = true
            }
            let subject = "";
            const response = await adminService.getCampaignStepTemplates(subjectFilter).then((resItem) => {
              subject = resItem.list.length > 0 ? resItem.list[0].message : "";

            });

          for (let index = 1; index < 7; index++) {
              let searchFilter = {
                currentPage: 1,
                cantPerPage: 1,
                step: index,
                campaign_step_template_type_id: 1,
                campaign_step_template_part_id: 1,
                isPreviewEmail: false,
                withTags: true,
                tag_id: state.step3.tag_id,
                language_id: state.language_id,
              };

              const resp = await adminService
                .getCampaignStepTemplates(searchFilter)
                .then((res) => {
                  state.modelCampaingStep.campaign_steps.push({
                    target_id: state.orderId,
                    step: index,
                    delay: index == 4 ? 60 : index > 1 ? 5 : 0,
                    time_to_send: "8",
                    subject: subject,
                    message: res.list[0].message,
                    recall_step: index == 4 ? 1 : 0,
                  });
                });
            }
            state.loading = false;
          }

        });

    },
    setCampaingSteps(state,data){
      state.modelCampaingStep.campaign_steps = data
    },

    setDisabledTab(state,id){
      state.tabs[id].disabled = true;
    },

    calculateSize(state) {
      let greater = 0;
      let less = 0;
      state.target.sizes.forEach((value, index) => {
        let keywords = state.select_list_sizes[value].label
          .replace("+", "")
          .split("-");
        if (!keywords[1]) {
          keywords[1] = "10000000";
        }
        if (Number(keywords[0]) < greater || greater === 0) {
          greater = Number(keywords[0]);
        }
        if (Number(keywords[1]) > less) {
          less = Number(keywords[1]);
        }
      });

      if (state.size.keywords == undefined) {
        state.size = { keywords: {} };
      }

      state.size.keywords.greater = greater;
      state.size.keywords.less = less;
    },
    calculatePrice(state) {
      let d = new Date();
      let ahora =
        [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");


      if (
        !(state.target_status_id ==
          4 || (state.target_status_id == 1 && state.step3.launchDate <= ahora))
      ) {
        if (state.apollo.total_result < state.limitA) {
          state.summary.progressBarColor = "bg-danger";
          state.summary.progressBarPercentage = "width: 40%";
          if (state.adminPrice != 1) {
            state.step3.appointmentPrice = 149;
          }
        } else if (state.apollo.total_result < state.limitB) {
          state.summary.progressBarColor = "bg-primary";
          state.summary.progressBarPercentage = "width: 70%";
          if (state.adminPrice != 1) {
            state.step3.appointmentPrice = 149;
          }
          if (state.apollo.total_result > state.limitC) {
            if (state.adminPrice != 1) {
              state.step3.appointmentPrice = 149;
            }
          }
        } else {
          state.summary.progressBarColor = "bg-success";
          state.summary.progressBarPercentage = "width: 95%";
          if (state.adminPrice != 1) {
            state.step3.appointmentPrice = 149;
          }
        }
        if (state.apollo.total_result == 0 && state.adminPrice != 1) {
          state.step3.appointmentPrice = 149;
        }
      }
    },
    getApollo(state, data) {
      state.isDisable = true;
      onboarding.mutations.setOrderData(state);
      let filters = state.orderdata.data;
      onboarding.mutations.calculateSize(state);
      if (state.size.keywords.less == 0 && state.size.keywords.greater == 0) {
        filters.employees = {};
      } else {
        if (state.size.keywords.less == 0 && state.size.keywords.greater > 0) {
          state.size.keywords = {
            greater: state.size.keywords.greater,
          };
        }
        filters.employees = state.size;
      }

      let categories_jobs;

      categories_jobs = filters.categories_jobs;
      categories_jobs = {
        anyof:
          categories_jobs.anyof !== undefined
            ? categories_jobs.anyof
            : undefined,
        notanyof:
          categories_jobs.notanyof !== undefined
            ? categories_jobs.notanyof
            : undefined,
        known:
          categories_jobs.known !== undefined
            ? categories_jobs.known
            : undefined,
        unknown:
          categories_jobs.unknown !== undefined
            ? categories_jobs.unknown
            : undefined,
      };
      filters.categories_jobs = categories_jobs;
      targetsService.getApollo(filters).then((response) => {
        if (response.pagination.total_entries > 60000000) {
          state.apollo.total_result = 0;
          state.apollo.people = [];
        } else {
          state.apollo.total_result = response.pagination.total_entries;
          state.apollo.people = response.people;
        }
        onboarding.mutations.calculatePrice(state);
        onboarding.mutations.validateForm(state);
        state.isDisable = false;
      });
    },
    save(state) {
      state.loading = true;

      let statesize;
      if (state.size.keywords == undefined) {
        statesize = {};
      } else {
        if (state.size.keywords.less == 0 && state.size.keywords.greater == 0) {
          statesize = {};
        } else {
          if (
            state.size.keywords.less == 0 &&
            state.size.keywords.greater > 0
          ) {
            statesize.keywords = {
              greater: statesize.keywords.greater,
            };
          } else {
            statesize = state.size;
          }
        }
      }

      state.orderdata.data.employees = statesize;

      targetsService.addTarget(state.orderdata).then((res) => {
        if (res != null && res != undefined && res > 0 && res) {
          state.orderId = res;
        }
        state.loading = false;
      });
    },
    copy(state) {
      state.orderId = 0;
      state.target_status_id = 3;
      state.orderName = state.orderName + " (Copy) ";
      state.salesRep = Array;
      state.step3.updateSales = Array;
      state.step3.teamMembers = Array;
      router.push("/orders/add");
    },
    goToSettingAccount(state, data){
      state.toSettingAccount = data;
    }
  },
  actions: {
    calculateSize(context){
      context.commit('calculateSize')
    },
    setTypeForm(context, data) {
      context.commit("setTypeForm", data);
    },
    validateForm(context, data) {
      context.commit("validateForm", data);
    },
    setOrderData(context, data) {
      context.commit("setOrderData", data);
    },
    setCampaingSteps(context, data) {
      context.commit("setCampaingSteps", data);
    },
    setDisabledTab(context,id){
      context.commit("setDisabledTab", id);
    },
    clean(context) {
      context.commit("clean");
    },
    save(context, data) {
      context.commit("setOrderData", data);
      context.commit("save");
    },
    setEmailDataToken(context, data) {
      context.commit("setEmailDataToken");
    },
    disableButton(context) {
      context.commit("disableButton");
    },
    changeLangAction(context, lang) {
      context.commit("changeLang", lang);
    },
    updateOrderName(context, orderName) {
      context.commit("updateOrderName", orderName);
      context.commit("disableButton");
    },
    updateDescriptionSell(context, descriptionSell) {
      context.commit("updateDescriptionSell", descriptionSell);
      context.commit("disableButton");
    },
    updateWebsite(context, website) {
      context.commit("updateWebsite", website);
    },
    updateTargetStatusId(context, targetStatusId) {
      context.commit("updateTargetStatusId", targetStatusId);
    },
    setOrderId(context, id) {
      context.commit("setOrderId", id);
    },
    setTab(context, id) {
      context.commit("setTab", id);
    },
    setLanguageId(context, id) {
      context.commit("setLanguageId", id);
    },
    updateProductName(context, productName) {
      context.commit("updateProductName", productName);
      context.commit("disableButton");
    },
    updateTagId(context, tagId) {
      context.commit("updateTagId", tagId);
      context.commit("disableButton");
    },
    updateDescription(context, args) {
      context.commit("updateDescription", args);
    },
    updateServiceDescription(context, args) {
      context.commit("updateServiceDescription", args);
      context.commit("disableButton");
    },
    updateOfferProspect(context,offer){
      context.commit("updateOfferProspect",offer)
    },
    skip(context, data) {
      context.commit("next");
      context.commit("disableSkip");
      context.commit("disableButton");
    },
    next(context, data) {
      context.commit("next");
      context.commit("disableButton");
      context.commit("disableSkip");
      context.commit("setOrderData", data);
      context.commit("save");
    },
    back(context) {
      context.commit("back");
      context.commit("disableButton");
      context.commit("disableSkip");
    },
    goTo(context, steps) {
      context.commit("goTo", steps);
    },
    goToStep(context, step) {
      context.commit("goToStep", step);
    },
    goToSubStep(context, substep) {
      context.commit("goToSubStep", substep);
    },
    updateAppointmentVolume(context, appointmentVolume) {
      context.commit("updateAppointmentVolume", appointmentVolume);
    },

    updateCompanyName(context, company) {
      context.commit("updateCompanyName", company);
    },

    updateSales(context, sales) {
      context.commit("updateSales", sales);
    },

    updateLaunchDate(context, launchDate) {
      context.commit("updateLaunchDate", launchDate);
    },
    apolloData(context, apollo) {
      context.commit("apolloData", apollo);
    },
    deleteTeamMember(context, indexMember) {
      let array = onboarding.state.step3.teamMembers;
      array.splice(indexMember, 1);
      context.commit("updateTeamMembers", array);
    },
    addTeamMember(context, target) {
      onboarding.state.step3.teamMembers.push(target);
      //context.commit('updateTeamMembers', array);
    },
    clearTeamMember(context) {
      onboarding.state.step3.teamMembers = [];
    },
    updatePositions(context, positions) {
      context.commit("updatePositions", positions);
    },
    updateDepartments(context, departments) {
      context.commit("updateDepartments", departments);
    },
    updateSizes(context, sizes) {
      context.commit("updateSizes", sizes);
    },
    updateSectorsExclude(context, sectors_exclude) {
      context.commit("updateSectorsExclude", sectors_exclude);
    },
    updateSectorsInclude(context, sectors_include) {
      context.commit("updateSectorsInclude", sectors_include);
    },
    updateCategoryJobs(context, categories_jobs) {
      context.commit("updateCategoryJobs", categories_jobs);
    },
    updateCountry(context, countries) {
      context.commit("updateCountries", countries);
    },
    updateRegion(context, regions) {
      context.commit("updateRegions", regions);
    },
    updateSummary(context, data) {
      context.commit("updateSummary", data);
    },
    updateBenefitsOffer(context,data){
      context.commit('updateBenefitsOffer',data);
    },
    updateOfferAttractive(context,data){
      context.commit('updateOfferAttractive',data);
    },
    loadTarget(context, data) {
      context.commit("loadTarget", data);
    },
    getApollo(context, data) {
      context.commit("getApollo", data);
    },
    updatePrice(context, data) {
      context.commit("updatePrice", data);
    },
    updateAdminPrice(context, data) {
      context.commit("updateAdminPrice", data);
    },
    updatePreviewTemplate(context, data) {
      context.commit("updatePreviewTemplate", data);
    },
    copy(context, data) {
      context.commit("copy", data);
    },
    goToSettingAccount(context, data) {
      context.commit("goToSettingAccount", data);
    },
  },
  getters: {
    getLang(state) {
      return state.lang;
    },
  },
};
